export default {
    path: '/dashboard/catalogue/:courseSlug',
    components: {
        default: () => import('../../views/memberDashboard/course/index.vue'),
        header: () => import('../../views/memberDashboard/header/index.vue'),
        footer: () => import('../../views/public/footer/index.vue'),
    },
    props: {
        default: true,
    },
    children: [
        /*
         * Course overview route
         */
        {
            path: '',
            name: 'memberDashboard.course.overview',
            props: true,
            meta: {
                menuLabel: 'Course Overview',
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member'],
                    mustBeActiveMember: true
                }
            },

            component: () => import('../../views/memberDashboard/course/components/overview.vue'),
        },
        /*
         * Course content route
         */
        {
            path: 'chapters/:order',
            name: 'memberDashboard.course.chapter',
            props: true,
            meta: {
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member'],
                    mustBeActiveMember: true
                }
            },

            component: () => import('../../views/memberDashboard/course/components/chapter.vue'),
        },
        /*
         * Video Course route
         */
        {
            path: 'video',
            name: 'memberDashboard.course.video',
            props: true,
            meta: {
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member'],
                    mustBeActiveMember: true
                }
            },

            component: () => import('../../views/memberDashboard/course/components/video.vue'),
        },
        /*
         * Assessment route
         */
        {
            path: 'assessment',
            name: 'memberDashboard.course.assessment',
            props: true,
            meta: {
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member'],
                    mustBeActiveMember: true
                }
            },

            component: () => import('../../views/memberDashboard/course/components/assessment.vue'),
        },
        {
            path: 'assessment/result',
            name: 'memberDashboard.course.assessment.result',
            props: true,
            meta: {
                middleware: {
                    mustBeAuthenticated: true,
                    mustHasRoles: ['member'],
                    mustBeActiveMember: true
                }
            },

            component: () => import('../../views/memberDashboard/course/components/assessmentResult.vue'),
        }
    ]
}